import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import '../Static.css'
import { useTranslation } from 'react-multi-lang'

const Help = () => {

    const t = useTranslation("static_pages.help_center");

    return (
        <>
            <Helmet>
                <script
                    src='//in.fw-cdn.com/32218506/1186004.js'
                    chat='true'>
                </script>
            </Helmet>
            <div className="static-pag-sec">
                <div className="static-page-header">
                    <Container fluid>
                        <Row className="justify-content-center">
                            <Col md="9">
                                <div className="static-section-title">
                                    <h1>{t('title')}</h1>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container fluid>
                    <div className="static-box">
                        <Row>
                            <Col md={12}>
                                <div className="static-card">
                                    <p>
                                        {t('heading')}
                                    </p>
                                    <h4>{t('support.title')}</h4>
                                    <p>{t('support.subtitle')}</p>
                                    <ul>
                                        <li>
                                            <strong>{t("support.email.title")}</strong><br />
                                            📧 {t("support.email.email")}: <a href="mailto:support@herald.exchange">support@herald.exchange</a><br />
                                            {t("support.email.content")}
                                        </li>
                                        <li>
                                            <strong>{t("support.live_chat.title")}</strong><br />
                                            {t("support.live_chat.content")}
                                        </li>
                                    </ul>

                                    <h4>{t("troubleshoot.title")}</h4>
                                    <p>{t("troubleshoot.subtitle")}</p>
                                    <ul>
                                        <li><strong>{t('troubleshoot.login.title')}</strong> {t('troubleshoot.login.content')}</li>
                                        <li><strong>{t('troubleshoot.transaction.title')}</strong> {t('troubleshoot.transaction.content')}</li>
                                        <li><strong>{t('troubleshoot.account.title')}</strong> {t('troubleshoot.account.content')}</li>
                                    </ul>
                                    <h4>{t("get_in_touch_title")}</h4>
                                    <p>{t("get_in_touch_subtitle")}</p>
                                    <div className="call-to-action-btn-sec">
                                        <Link className="new-default-primary-btn" to="/contact-us">
                                            {t("contact_us")}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"><path stroke="#171717" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M14.43 5.93L20.5 12l-6.07 6.07M11.01 12h9.32M3.5 12h3.47"></path></svg>
                                        </Link>
                                        <Link className="new-default-primary-btn" to={-1}>
                                            {t("back")}
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </>
    )
}

export default Help